import http, { createApi } from '@core/fetch'

export default {
  // 首页
  // 内容中心首页
  getWebIndex: body =>
    http('/p/wedding/index.php/admin/APICreateStar/webIndex', { body }),
  // 讨论
  getHotDiscuss: body =>
    http('/p/wedding/index.php/admin/APICreateStar/hotDiscuss', { body }),
  // 首页数据
  getIndexData: body =>
    http('/p/wedding/index.php/admin/APICreateStar/starData', { body }),

  // 我的创作
  // 我的动态列表web (个人)
  getMyNoteList: body =>
    http('/p/wedding/index.php/admin/APINote/myNoteList', {
      body
    }),
  getTeamNoteList: body =>
    http('/p/wedding/index.php/mainAdmin/APINote/MyNotes', {
      body
    }),
  // 我的回答列表（web）
  getMyAnswerList: body =>
    http('/p/wedding/index.php/admin/APIQaAnswer/myAnswerList', {
      body
    }),

  // 删除动态
  modifyNote: body =>
    http.post('/p/wedding/Home/APINote/modify', {
      body
    }),

  // 置顶动态
  setTop: createApi.post('/p/wedding/index.php/admin/APINote/setIsTop'),

  // 社区问答
  // 推荐问题
  getRecQuestion: body =>
    http('/p/wedding/index.php/admin/APIQaQuestion/recQuestion', { body }),

  // 邀请回答
  getInvite: body => http('/hps/admin/mix/qaQuestion/invite', { body }),

  // 我的关注
  getFollowQuestion: body =>
    http('/p/wedding/index.php/admin/APIQaQuestion/followQuestion', { body }),

  // 问题-关注
  follow: body =>
    http.post('/p/wedding/index.php/Home/APIFollow/follow', {
      body
    }),

  // 问题--取消关注
  unfollow: body =>
    http.post('/p/wedding/index.php/Home/APIFollow/unfollow', {
      body
    }),

  //商家发布动态限制
  noteCheckLimit: body =>
    http('/p/wedding/index.php/admin/APINote/noteCheckLimit', { body }),

  // 动态详情
  getDynamicDetail: body =>
    http('/p/wedding/index.php/home/APINote/detail', { body }),

  // 动态详情评论
  getCommentList: body =>
    http('/p/wedding/index.php/Home/APICommunityComment/listV2', { body }),

  //评论 && 回复评论
  postComment: body =>
    http.post('/p/wedding/index.php/Home/APICommunityComment/addFunc', {
      body
    }),
  //评论 && 回复评论 （video类型的）
  postCommentVideo: body =>
    http.post('/p/wedding/home/APIMixComment/add', {
      body
    }),
  //删除某条评论
  delComment: body =>
    http.post('/p/wedding/index.php/Home/APICommunityComment/deleteFunc', {
      body
    }),
  //删除某条评论 - video类型
  delCommentVideo: body =>
    http.post('/p/wedding/index.php/Home/APIMixComment/delete', {
      body
    }),

  //发布动态
  publishNote: body =>
    http.post('/p/wedding/index.php/Home/APINote/create', {
      body,
      ignore: [null, undefined]
    }),

  // 问题详情
  getCommunityDetail: body =>
    http('/p/wedding/index.php/admin/APIQaQuestion/detailV2', { body }),

  // 回答问题/编辑回答
  postCommunity: body =>
    http.post('/p/wedding/index.php/home/APIQaAnswer/edit', { body }),
  getTags: createApi('/p/wedding/index.php/admin/APISetMeal/mealMarks'),

  // 新片预告发布相关信息
  getMerchantPhotoAlbumInfo: () =>
    http.get('/hms/hljLocalserviceProduct/adminApi/note/photoAlbumInfo'),
  // 获取案例列表
  getCaseList: (pageNum, pageSize = 10) =>
    http.get('/hms/hljLocalserviceProduct/adminApi/note/setMealList', {
      body: {
        pageSize,
        pageNum
      }
    }),
  //案例转化为动态，获取案例中的标题、图片、视频
  getCaseDetail: body =>
    http.get('/hms/hljLocalserviceProduct/adminApi/setMeal/info', {
      body
    })
}
